import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface AnnouncementItem {
  id: string;
  text_lv: string;
  text_en: string;
  text_ru: string;
  link_url: string | null;
  sort_order: number;
}

export function useAnnouncements() {
  const [announcements, setAnnouncements] = useState<AnnouncementItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchItems = async () => {
      const { data, error } = await supabase
        .from("announcement_bar")
        .select("id, text_lv, text_en, text_ru, link_url, sort_order")
        .eq("is_active", true)
        .order("sort_order", { ascending: true });

      if (!cancelled) {
        if (!error && data) setAnnouncements(data as AnnouncementItem[]);
        setLoading(false);
      }
    };
    fetchItems();
    return () => {
      cancelled = true;
    };
  }, []);

  return { announcements, loading };
}
